<template>
    <div>
        <div
            style="max-width: 100%; overflow: hidden;" 
            :class="[
                !imgHref ? 'n-image' : '',
                'form-image',
            ]">
            <div v-if="imgHref">
                <div style='text-align: left;'>
                    <a :href="imgHref">
                        {{ fileName }}
                    </a>
                </div>
            </div>
            <input 
                class="abs-input"
                ref="theFile"
                type="file"
                accept=""
                @change="onFileChanged" >
        </div>
        <div>
            <button 
                @click="onBtnClick"
                :cls="[
                    cls ? cls : 'mt-2 mr-1 mb-1 ',
                ]"
                class="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
                type="button">
                <span v-if="imgHref && imgHref != ''">Заменить файл</span>
                <span v-else>Выбрать файл</span>
            </button>
        </div>
    </div>
</template>


<script>

export default {
    components: {},
    mounted() {
        this.imgHref = this.modelValue;
    },
    data () {
        return {
            imgHref: '',
            fileName: '',
        };
    },
    methods: {
        getFIleName() {
            const parts = this.imgHref.split("/");
            return parts[parts.length - 1];
        },
        onFileChanged(e) {
            const input = e.target;
            var ext = input.files[0]['name'].substring(input.files[0]['name'].lastIndexOf('.') + 1).toLowerCase();
            const self = this;
            if (input.files && input.files[0] && ext) {
                var reader = new FileReader();
                reader.onload = function (e) {
                    self.fileName = input.files[0].name;
                    self.imgHref = e.target.result;
                    self.$emit('update:modelValue', input.files[0]);
                }
                reader.readAsDataURL(input.files[0]);
            }
        },
        onBtnClick() {
            this.$refs.theFile.click();
        }
    },
    props: { 
        cls: null,
        modelValue: null,
    },
}
</script>

<style scoped>
    .abs-input {
        position: absolute;
        left: -200%;
    }
</style>